import omit from 'lodash/omit';

const PARSED_VALUES: string[] = ['linkParameters', 'images'];

const parseDefaultValues = (dashboardContainer: ContentContainer) => {
  const result: Partial<ContentContainer> = {
    ...omit(dashboardContainer, PARSED_VALUES),
  };

  result.linkParametersAttributes = dashboardContainer?.linkParameters;
  result.imagesAttributes = dashboardContainer?.images;
  result.kind = dashboardContainer?.componentKind;

  return result;
};

export default parseDefaultValues;
